<template>
  <div id="app">
    <t-header v-if='!$route.meta.hideHeader'/>
    <div class='page-main'>
      <router-view />
    </div>
    <t-footer v-if='!$route.meta.hideFooter'/>
  </div>
</template>

<script>
// import THeader from './components/header';
import THeader from './components/headerMLT.vue';
import TFooter from './components/footer';
export default {
  name: 'App',
  components: {
    THeader,
    TFooter,
  },
  methods: {
    handleTop() {
      window.scrollTo(0, 0);
    }
  },
}
</script>

<style lang='less'>
#app {
  position: relative;
  .swiper-pagination-white{
    span{
      width: 40px !important;
      height: 4px !important;
      border-radius: inherit !important;
      opacity: 0.4;
      &.swiper-pagination-bullet-active{
        opacity: 1;
      }
    }
  }
  .page-main {
    min-height: 400px;
  }
  >.contact-me {
    position: fixed;
    top: 50%;
    transform: translate(0, -50%);
    z-index: 999;
    right: 0;
    width: 45px;
    li {
      height: 45px;
      width: 45px;
      margin-bottom: 1px;
      float: right;
      background: #1b1b1d;
      line-height: 45px;
      font-size: 14px;
      cursor: pointer;
      position: relative;
      transition: width .5s, background .3s;
      a {
        color: #fff;
      }
      b {
        width: 45px;
        height: 45px;
        display: block;
        overflow: hidden;
        float: left;
        background: url(./assets/contact.png) no-repeat;
      }
      &.top {
        color: #fff;
        font-weight: bold;
        font-family: Arial, Helvetica, sans-serif;
        text-align: center;
        line-height: 45px;
        background: #ccc;
        position: relative;
        width: 45px;
        cursor: pointer;
        transition: background .3s;
        &:hover {
          background: #c9112c;
          color: #fff;
        }
      }
      &:hover {
        background: #c9112c;
      }
      &.qq, &.sms, &.wx, &.qrcode {
        overflow: hidden;
        &:hover {
          width: 115px;
        }
        &.qq b {
          background-position: 7px -162px;
        }
        &.sms b {
          background-position: 7px -206px;
        }
        &.wx b {
          background-position: 7px -255px;
        }
        &.qrcode {
          overflow: unset;
          &:hover {
            width: 45px;
            .te-r-weixin {
              display: block;
            }
          }
          b {
            background-position: 7px -345px;
          }
          .te-r-weixin {
            height: 150px;
            position: absolute;
            top: -107px;
            left: -146px;
            background: #FFF;
            border: 1px solid #CCC;
            cursor: default !important;
            width: 139px;
            display: none;
            p {
              line-height: 20px;
              color: #000;
              font-size: 12px;
              text-align: center;
              float: left;
              width: 130px;
              img {
                width: 110px;
                height: 110px;
                margin: 10px 10px 0px 10px;
              }
            }
          }
        } 
      }
    }
  }
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: PingFangSC, PingFangSC-Regular;
}
html {
  font-size: 12px;
  font-weight: 400;
  color: #333333;
  min-width: 1240px;
}
ul {
  list-style-type: none;
}
.v-note-wrapper.markdown-body ul {
  list-style-type: initial;
}

a {
  text-decoration: none;
}
</style>
